import { Button, Flex, IconStudentViewLine, Text } from "@instructure/ui";
import { t } from "i18next";
import styled from "styled-components";
import { Card } from "../../../../components/Card";

const AssignmentCardStyle = styled(Card)`
  text-align: left;
  position: relative;
  border: 1px solid transparent;
  cursor: pointer;
  padding: 0;
  &:hover {
    border-color: #000;
    ${(props) => `background-color: ${props.color};`}
  }
  ${(props) => props.$current && `background-color: ${props.color};`}
`;

const AssignmentCard = ({
  assignment,
  selectedAssignment,
  section,
  handleAssignmentSelect,
}) => {
  return (
    <AssignmentCardStyle
      $current={
        assignment.assignment.id === selectedAssignment?.assignment?.id &&
        section.current
      }
      color="#D2E3F6"
    >
      <Button
        color="secondary"
        textAlign="start"
        withBackground={false}
        size="small"
        display="block"
        themeOverride={{
          borderRadius: 0,
          borderStyle: "none",
          borderWidth: 0,
          padding: 0,
          secondaryHoverBackground: "transparent",
          secondaryGhostHoverBackground: "transparent",
          smallPaddingBottom: 5,
          smallPaddingTop: 5,
          smallPaddingHorizontal: 5,
        }}
        onClick={() => handleAssignmentSelect(assignment, section)}
      >
        <Flex alignItems="start" justifyItems="space-between" gap="small">
          <Flex.Item shouldShrink shouldGrow>
            <Text size="small">
              {assignment.assignment
                ? section.canvas_id !== -1
                  ? assignment.assignment.name
                  : t("assessment.externalAssessment")
                : t("dashboard.unplannedAssignment")}
            </Text>
          </Flex.Item>
          <Flex.Item>
            {selectedAssignment?.assignment?.id === assignment.assignment.id &&
              section.current && <IconStudentViewLine size="x-small" />}
          </Flex.Item>
        </Flex>
      </Button>
    </AssignmentCardStyle>
  );
};

export default AssignmentCard;
